import { Component, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../services/auth.service'; // Assuming you have an AuthService to get the current user
import firebase from 'firebase/app';
import 'firebase/firestore';

@Component({
    selector: 'app-add-library-web-source',
    templateUrl: './add-library-web-source.component.html',
    styleUrls: ['./add-library-web-source.component.scss'],
    standalone: false
})
export class AddLibraryWebSourceComponent implements OnInit {
  urlForm: UntypedFormGroup;
  urls: { title: string; url: string }[] = [];
  ownerID: string;

  constructor(
    private fb: UntypedFormBuilder,
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.urlForm = this.fb.group({
      title: ['', Validators.required],
      url: ['', [Validators.required, Validators.pattern('https?://.+')]]
    });
  }

  ngOnInit() {
    this.authService.currentUser.subscribe(user => {
      this.ownerID = user.uid;
      this.loadUrls();
    });
  }

  loadUrls() {
    firebase
      .firestore()
      .collection('websources')
      .doc(this.ownerID)
      .get()
      .then(doc => {
        if (doc.exists) {
          this.urls = doc.data().sources || [];
        }
      });
  }

  addUrl() {
    if (this.urlForm.valid) {
      const { title, url } = this.urlForm.value;
      if (!this.urls.some(u => u.url === url)) {
        this.validateUrl(url).then(isValid => {
          if (isValid) {
            this.urls.push({ title, url });
            this.urlForm.reset();
          } else {
            alert('The URL is invalid or unreachable. Please modify or delete it.');
          }
        });
      } else {
        alert('This URL is already in the list.');
      }
    }
  }

  deleteUrl(index: number) {
    this.urls.splice(index, 1);
  }

  saveUrls() {
    firebase
      .firestore()
      .collection('websources')
      .doc(this.ownerID)
      .set({
        ownerID: this.ownerID,
        sources: this.urls
      })
      .then(() => {
        alert('Sources saved successfully.');
      })
      .catch(error => {
        console.error('Error saving sources: ', error);
      });
  }

  async validateUrl(url: string): Promise<boolean> {
    try {
      const proxyUrl = 'https://api.allorigins.win/get?url=';
      const response = await firstValueFrom(this.http.get(proxyUrl + encodeURIComponent(url), { observe: 'response' }));
      return response.status === 200;
    } catch {
      return false;
    }
  }
}
